export function assertValue<T>(value: T | null | undefined, message: string): asserts value is NonNullable<T> {
  if (value === null || value === undefined) throw new Error(message);
}

export function requireValue<T>(value: T | null | undefined, message: string): NonNullable<T> {
  if (value === null || value === undefined) throw new Error(message);
  return value;
}
